import styled, { css } from "styled-components";
import { COLORS, FONT_SIZE, SUPER_BREAKPOINT } from "../../../constants/Styles";
import Link from "next/link";

export const CategoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ComponentsDescription = styled.div`
  font-size: ${FONT_SIZE.size18};
  color: ${COLORS.secondaryLight};
  padding: 0 1rem;
  text-align: center;
  max-width: ${SUPER_BREAKPOINT};
  text-wrap: balance;
`;

export const CategoryCardsContainer = styled.div<{ $smallCard: boolean }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  max-width: 1100px;
  font-size: ${({ $smallCard }) =>
    $smallCard ? FONT_SIZE.size12 : "inherit"}};
  @media (max-width: ${SUPER_BREAKPOINT}) {
    padding: 0 1rem;
  }
`;

export const SearchBarContainer = styled.div`
  margin: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const CARD_SIZE = "156px";
const SMALL_CARD_SIZE = "103px";

const cardStyles = css<{ $smallCard: boolean }>`
  border-radius: 1rem;
  background-color: ${COLORS.inputGray};
  width: ${({ $smallCard }) => ($smallCard ? SMALL_CARD_SIZE : CARD_SIZE)};
  height: ${({ $smallCard }) => ($smallCard ? SMALL_CARD_SIZE : CARD_SIZE)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: ${({ $smallCard }) => ($smallCard ? "1rem" : "1.5rem")};
  &:hover {
    background-color: ${COLORS.altSecondary};
  }
`;

export const CategoryCard = styled.div<{ $smallCard: boolean }>`
  ${cardStyles};
  cursor: pointer;
`;

export const CategoryCardLink = styled(Link)<{ $smallCard: boolean }>`
  ${cardStyles};
  text-decoration: none;
`;

export const CategoryName = styled.div<{ $smallCard: boolean }>`
  margin-top: ${({ $smallCard }) => ($smallCard ? "0" : "0.5rem")};
  color: ${COLORS.secondaryLight};
`;

export const AdditionalActionsContainer = styled.div`
  margin-top: 2rem;
`;
